import { useState } from 'react';
import Logo from '@/components/common/Logo';
import MenuItem from './components/MenuItem/MenuItem';
import { useTranslation } from 'react-i18next';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import useAuthorization from "@/hooks/useAuthorization";
import {getMenuConfig} from "@/components/Layout/components/SideMenu/menuConfig";
import HelpDrawer from "@/components/Help/HelpDrawer";

const DesktopSideMenu = () => {
    const { t } = useTranslation();
    const { hasLevel } = useAuthorization();
    const [isHelpOpen, setIsHelpOpen] = useState(false);

    const menuConfig = getMenuConfig(t, hasLevel);

    return (
        <aside className="hidden sm:flex flex-col bg-[#F1EDE7] w-[250px] flex-shrink-0 shadow-lg overflow-y-auto">
            {/* Logo Section */}
            <div className="px-6 py-6 flex justify-center">
                <Logo className="w-[150px] h-auto" alt="Logo" />
            </div>

            {/* Navigation Section */}
            <nav className="flex flex-col items-start justify-start w-full px-4 pt-4 flex-1">
                <ul className="space-y-2 w-full">
                    {menuConfig.map((item, index) => (
                        <MenuItem key={index} {...item} />
                    ))}
                </ul>
            </nav>

            {/* Help entry pinned at the bottom */}
            <div className="px-4 py-4 border-t border-[#e1dccd]">
                <button
                    type="button"
                    onClick={() => setIsHelpOpen(true)}
                    className="flex w-full items-center text-black hover:bg-light-bunker hover:text-black cursor-pointer rounded-lg px-4 py-2"
                >
                    <QuestionMarkCircleIcon className="h-5 w-5 mr-3 flex-shrink-0" />
                    <span className="text-sm truncate">{t('sidebar.menu.help')}</span>
                </button>
            </div>

            <HelpDrawer
                isOpen={isHelpOpen}
                onClose={() => setIsHelpOpen(false)}
                mode="general"
            />
        </aside>
    );
};

export default DesktopSideMenu;
